/*
 * Copyright (c) 2020. American Express Company
 */

// third-party
import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import LiteralsService from '../../services/literals/LiteralsService';

// components
import GoalDrawer from './GoalDrawer';
import JobPicker from '../job-picker/JobPicker';

// icons and styles
import { ReactComponent as PalmTreeIcon } from 'src/bw/goal/palm-tree.svg';
import { ReactComponent as PersonalItemsIcon } from 'src/bw/goal/personal-items.svg';
import { ReactComponent as RockingChairIcon } from 'src/bw/goal/rocking-chair.svg';

export default class LoseJobDrawer extends Component<any, any> {
    private readonly handleUpdateOnce: () => void = _.once(() => {
        this.props.drawerProps.card.attributes.updated = Date.now(); // force an updated to trigger temp step 6
        this.props.handleUpdateCard();
    });

    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;
        const incomeSources = this.props.validIncomeSourcesToEnd(drawerProps.card, drawerProps.incomeSources);

        let jobLabel: string = '';
        let icon: JSX.Element = null;

        switch (drawerProps.card.description) {
            case 'lose job':
                icon = <PersonalItemsIcon />;
                jobLabel = LiteralsService.getLiteral('LoseJobDrawer.lose.incomeSourceLabel');
                break;

            case 'quit job':
                icon = <PalmTreeIcon />;
                jobLabel = LiteralsService.getLiteral('LoseJobDrawer.quit.incomeSourceLabel');
                break;

            case 'retire':
                icon = <RockingChairIcon />;
                jobLabel = LiteralsService.getLiteral('LoseJobDrawer.retire.incomeSourceLabel');
                break;
        }

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={icon}
                introContent="NEEDS INTRO CONTENT"
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                startDateLabel={'Date'}
                bottomButtonUpdate={this.handleUpdateOnce}
            >
                <JobPicker
                    label={jobLabel}
                    value={drawerProps.card.modifyIncomes[0] || ''}
                    onChange={(e: any) => {
                        this.props.handleChangeCard(drawerProps.card, e.target.value, 'modifyIncomes');
                    }}
                    incomeSources={incomeSources}
                    hasInvalidIncome={drawerProps.card.warnings?.length > 0}
                />
            </GoalDrawer>
        );
    }
}
